import { SliderGalerieImages } from '@components/slider-galerie-images/models';
import { imageMock } from '@mock/schema/components/shared';
import { Block } from '@shared/models';

export const sliderGalerieImagesMock: Block<SliderGalerieImages> = {
  type: 'slider-galerie-images',
  data: {
    images: Array(5).fill(imageMock),
  } as SliderGalerieImages,
};
